export function selectedGroupData(state = {}, action: any) {
  switch (action.type) {
    case 'SELECTED_GROUP':
      return action.data;
    default:
      return state;
  }
}

export function clearSearchGroup(state = {}, action: any) {
  switch (action.type) {
    case 'CLEAR_SELECTED_GROUP':
      return action.data;
    default:
      return state;
  }
}

// seleted tags

export function selectedTagData(state = {}, action: any) {
  switch (action.type) {
    case 'SELECTED_TAG':
      return action.data;
    default:
      return state;
  }
}

export function clearSearchTag(state = {}, action: any) {
  switch (action.type) {
    case 'CLEAR_SELECTED_TAG':
      return action.data;
    default:
      return state;
  }
}
